<ng-container *ngIf="users$ | async as users" [formGroup]="formParent">
  <mat-form-field class="fuse-mat-dense flex-auto w-full">
    <mat-select [formControlName]="formFieldControl">
      <mat-option [value]="user.username" *ngFor="let user of users">
        {{ user?.nome || user?.username }} - {{ user?.email }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</ng-container>
